import request from '../../utils/request';
const Authorization = localStorage.getItem("Authorization");
// 素材库分页查询
export function getChatMaterial(params,Authorization) {
  return request({
    url: '/api/chatMaterial/selectPage',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
    
  })
}
// 保存素材
export function saveMaterial(params,Authorization) {
  return request({
    url: '/api/chatMaterial/save',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
    
  })
}
// 修改素材
export function updateMaterial(params,Authorization) {
  return request({
    url: '/api/chatMaterial/update',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 删除素材
export function deleteMaterial(id,Authorization) {
  return request({
    url: '/api/chatMaterial/'+id,
    method: 'delete',
    headers: {
      "authorization": Authorization
    }
  })
}

// 短信群发列表
export function taskList(params,Authorization,isloading) {
  return request({
    url: '/api/msg/task/list',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 短信群发详情
export function contentDetail(id,Authorization,isloading) {
  return request({
    url: '/api/msg/task/'+id,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 短信群发新增
export function newTask(params,Authorization) {
  return request({
    url: '/api/msg/task/save',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 客户群发-统计选中的客户数量
export function countCus(params,Authorization) {
  return request({
    url: '/api/msg/task/countCus',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 客户群发-获取标签
export function getTags(Authorization) {
  return request({
    url: '/api/msg/task/tags',
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 批量上传文件
export function savefile(params,Authorization) {
  return request({
    url: '/api/chatMaterial/saveFile',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization,
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 分类列表
export function getTypeList() {
  return request(
    {
      url: "/api/chatMaterial/type/selectTypePage",
      method: "post",
      headers: {
        "authorization": Authorization,
      },
    },
  );
}
// 获取一级分类
export function getFirstLevel() {
  return request({
    url: "/api/chatMaterial/type/selectType/first",
    method: "get",
    headers: {
      "authorization": Authorization,
    },
  });
}
// 获取二级分类
export function getSecondLevel(parentId) {
  return request({
    url: `/api/chatMaterial/type/selectType/second/${parentId}`,
    method: "get",
    headers: {
      "authorization": Authorization,
    },
  });
}
// 获取三级分类
export function getThirdLevel(parentId) {
  return request({
    url: `/klb-service/api/chatMaterial/type/selectType/third/${parentId}`,
    method: "get",
    headers: {
      "authorization": Authorization,
    },
  });
}
// 查询所有分类（树形列表）
export function selectAllType(params) {
  return request({
    url: "/api/chatMaterial/type/selectAll",
    method: "get",
    params,
    headers: {
      "authorization": Authorization,
    },
  });
}
// 保存分类（新增/修改/删除统一接口）
export function saveType(params) {
  return request({
    url: "/api/chatMaterial/type/save",
    method: "post",
    data: params,
    headers: {
      "authorization": Authorization,
    },
  });
}

// 新增分类
export function addTypeList(params) {
  return request({
    url: "/api/chatMaterial/type",
    method: "post",
    data: params,
    headers: {
      "authorization": Authorization,
    },
  })
}
// 删除分类
export function deleteTypeList(id) {
  return request({
    url: `/api/chatMaterial/type?id=${id}`,
    method: "delete",
    headers: {
      "authorization": Authorization,
    },
  })
}
// 修改分类
export function putTypeList(params) {
  return request({
    url: `/api/chatMaterial/type`,
    method: "put",
    data: params,
    headers: {
      "authorization": Authorization,
    },
  })
}
// 分页查询根据等级查询分类
export function selectLevelList(level,params) {
  return request({
    url: `/api/chatMaterial/type/selectLevelList?level=${level}`,
    method: "post",
    data: params,
    headers: {
      "authorization": Authorization,
    },
  })
}


// 批量修改 
export function selectPageUpdate(params) {
  return request({
    url: `/api/chatMaterial/selectPageUpdate`,
    method: "put",
    data: params,
    headers: {
      "authorization": Authorization,
    },
  })
}